<template>
  <div class="vpayAccountOrder-details">
    <div class="breadcrumb" style="background: #fff">余额交易明细</div>
    <div class="order-detail-basic">
      <el-form label-width="100px">
        <el-form-item v-for="(v,k) in filterOrder" :key='k' :label="label[k]+':'">{{v}}</el-form-item>
      </el-form>
    </div>
    <div class="edit-button">
      <el-button round type="primary" @click="returnPage">返回</el-button>
    </div>
  </div>
</template>
<script>
import { vpayOrderGetById } from '@/api/epay'
export default {
  name: 'VpayChargeDetail',
  data () {
    return {
      label: {
        orderId: 'ID',
        outOrderNo: '外部订单号',
        serialNo: '交易流水号',
        amount: '支付金额',
        bonus: '支付虚拟充值',
        tradeType: '交易类型',
        tradeMethod: '交易方式',
        paymentType: '支付类型',
        paymentStatus: '支付状态',
        paymentDate: '支付日期'
      },
      order: {}
    }
  },
  created () {
    this.init()
  },
  computed: {
    filterOrder () {
      let _order = {}
      Object.keys(this.label).forEach(key => {
        let val = this.order[key]
        if (/tradeType|paymentType|paymentStatus/ig.test(key)) {
          val = this.$config[key] ? this.$config[key][val] : val // ?
        }
        if (/(tradeMethod)/ig.test(key)) {
          val = this.$config.vpayTradeMethod[val] || val
        }
        _order[key] = val
      })
      return _order
    }
  },
  methods: {
    init () {
      vpayOrderGetById(this.$route.query.id).then(res => {
        this.order = res.data.data
      })
    },
    returnPage () {
      if (window.history.length <= 1) {
        this.$router.push({ path: '/home' })
        return false
      } else {
        this.$router.go(-1)
      }
    }
  }
}
</script>
 <style scoped lang="less">
.recharge-details {
  .el-input {
    @{deep} .el-input__inner {
      //color: #F56C6C;
      -moz-appearance: textfield;
    }
    @{deep} .el-input__inner::-webkit-inner-spin-button,
    @{deep} .el-input__inner::-webkit-outer-spin-button {
      -webkit-appearance: none;
      margin: 0;
    }
  }
}
@deep: ~">>>";
</style>
